import React from "react";
import { Card, FormGroup, Input, Label } from "reactstrap";

const PaymentMethodCard = ({
  darkMode,
  color,
  methodName,
  displayName,
  disabled,
  paymentMethod,
  setPaymentMethod,
  setRenderCards,
  shouldRenderCards,
}) => (
  <Card
    className={
      darkMode
        ? "p-3 mb-3 cart__payment_card-dark"
        : "p-3 mb-3 cart__payment_card"
    }
  >
    <FormGroup check>
      <Label check className="fs--18 fw--600">
        <Input
          type="radio"
          name="pay"
          defaultValue={paymentMethod}
          disabled={disabled}
          onChange={() => {
            setPaymentMethod(methodName);
            if (setRenderCards) setRenderCards(shouldRenderCards);
          }}
          style={{ "--accent-color": color }}
        />{" "}
        {displayName}
      </Label>
    </FormGroup>
  </Card>
);

export default PaymentMethodCard;
